import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { COMMON_STANDALONE_IMPORTS } from 'src/app/components/common-standalone-imports';

@Component({
  imports: [COMMON_STANDALONE_IMPORTS],
  selector: 'formly-switch',
  templateUrl: './formly-switch.component.html',
})
export class FormlySwitchComponent extends FieldType {}
